/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { InImageDTO } from "./InImageDTO";
import { InImageDTOFromJSON, InImageDTOFromJSONTyped, InImageDTOToJSON } from "./InImageDTO";
import type { PlatformRefDTO } from "./PlatformRefDTO";
import { PlatformRefDTOFromJSON, PlatformRefDTOFromJSONTyped, PlatformRefDTOToJSON } from "./PlatformRefDTO";
import type { SeoDTO } from "./SeoDTO";
import { SeoDTOFromJSON, SeoDTOFromJSONTyped, SeoDTOToJSON } from "./SeoDTO";

/**
 *
 * @export
 * @interface InProductDTO
 */
export interface InProductDTO {
  /**
   *
   * @type {number}
   * @memberof InProductDTO
   */
  id: number;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  title: string;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  ean?: string;
  /**
   *
   * @type {PlatformRefDTO}
   * @memberof InProductDTO
   */
  platform: PlatformRefDTO;
  /**
   *
   * @type {boolean}
   * @memberof InProductDTO
   */
  live: boolean;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  slug: string;
  /**
   *
   * @type {InImageDTO}
   * @memberof InProductDTO
   */
  image?: InImageDTO;
  /**
   *
   * @type {SeoDTO}
   * @memberof InProductDTO
   */
  seo?: SeoDTO;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  description?: string;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  specification?: string;
  /**
   *
   * @type {Date}
   * @memberof InProductDTO
   */
  updatedAt?: Date;
  /**
   *
   * @type {string}
   * @memberof InProductDTO
   */
  createdAt?: string;
}

/**
 * Check if a given object implements the InProductDTO interface.
 */
export function instanceOfInProductDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "id" in value;
  isInstance = isInstance && "title" in value;
  isInstance = isInstance && "platform" in value;
  isInstance = isInstance && "live" in value;
  isInstance = isInstance && "slug" in value;

  return isInstance;
}

export function InProductDTOFromJSON(json: any): InProductDTO {
  return InProductDTOFromJSONTyped(json, false);
}

export function InProductDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): InProductDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json["id"],
    title: json["title"],
    ean: !exists(json, "ean") ? undefined : json["ean"],
    platform: PlatformRefDTOFromJSON(json["platform"]),
    live: json["live"],
    slug: json["slug"],
    image: !exists(json, "image") ? undefined : InImageDTOFromJSON(json["image"]),
    seo: !exists(json, "seo") ? undefined : SeoDTOFromJSON(json["seo"]),
    description: !exists(json, "description") ? undefined : json["description"],
    specification: !exists(json, "specification") ? undefined : json["specification"],
    updatedAt: !exists(json, "updatedAt") ? undefined : new Date(json["updatedAt"]),
    createdAt: !exists(json, "createdAt") ? undefined : json["createdAt"]
  };
}

export function InProductDTOToJSON(value?: InProductDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    title: value.title,
    ean: value.ean,
    platform: PlatformRefDTOToJSON(value.platform),
    live: value.live,
    slug: value.slug,
    image: InImageDTOToJSON(value.image),
    seo: SeoDTOToJSON(value.seo),
    description: value.description,
    specification: value.specification,
    updatedAt: value.updatedAt === undefined ? undefined : value.updatedAt.toISOString(),
    createdAt: value.createdAt
  };
}
